import { css, cx } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  SelectValue as AriaSelectValue,
  SelectValueProps,
} from "react-aria-components";

import { Skeleton } from "../../../../patterns/skeleton/Skeleton";
interface Props<T extends object> extends SelectValueProps<T> {
  isLoading?: boolean;
}

export function _SelectValue<T extends object>(props: Props<T>) {
  const { isLoading, ...selectValueProps } = props;

  if (isLoading) {
    return (
      <Skeleton
        width={200}
        textStyle="input/text-field"
        className={styles.loadingSkeleton}
      />
    );
  }

  return (
    <AriaSelectValue
      {...mergeProps(selectValueProps, {
        className: cx("react-aria-SelectValue", styles.value),
      })}
    />
  );
}

const styles = {
  loadingSkeleton: css({
    flex: 1,
    display: "inline-flex",
    alignItems: "center",
  }),
  value: css({
    "&[data-placeholder]": { color: "var(--text-placeholder)" },
  }),
};
